import { Component, Input } from '@angular/core';
import { Station } from 'src/tmc-yard/client/model/station';
import { StationSet } from 'src/tmc-yard/client/model/station-set';

@Component({
  selector: 'app-sac-mobile-transport-actions',
  templateUrl: './transport-actions.component.html',
  styleUrls: ['./transport-actions.component.scss']
})
export class MobileSacTransportActionsComponent {

  @Input() station: Station;

  @Input() stationSet: StationSet;

  

}
